import { Dropdown } from 'primereact/dropdown';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import i18n from '../../i18n';
import AccountService from '../../services/AccountService';
import AuthService from '../../services/AuthService';
import UserService from '../../services/UserService';
import ActionButton from '../ActionButton';
import ActionLink from '../ActionLink';
import TooltipComponent from '../TooltipComponent';
import InputAutocompleteComponent from '../inputs/InputAutocompleteComponent';
import I18nUtils from '../utils/I18nUtils';
import BlockUi from '../waitPanel/BlockUi';
import NotificationComponentProp from './NotificationComponentProp';
class HeaderComponent extends Component {
    constructor(props) {
        super(props);
        this.authService = new AuthService();
        this.userService = new UserService();
        this.accountService = new AccountService();
        const {t} = props;
        this.state = {
            timer: this.authService.expirationTimer(),
            loggedIn: this.authService.loggedIn(),
            sapRoleId: this.authService.getProfile().agreementSapRoleId,
            userLoggedIn: this.authService.getProfile(),
            nameTooltipVisible: false,
            loadingCbk: false,
            translations: {
                'header.notification.clear': t('header.notification.clear'),
                'header.notification.title.video.INITIALIZED': t('header.notification.title.video.INITIALIZED'),
                'header.notification.title.video.DOWNLOADING': t('header.notification.title.video.DOWNLOADING'),
                'header.notification.title.video.AWAIT_STACKING': t('header.notification.title.video.AWAIT_STACKING'),
                'header.notification.title.video.STACKING': t('header.notification.title.video.STACKING'),
                'header.notification.title.video.ERROR': t('header.notification.title.video.ERROR'),
                'header.notification.title.video.READY': t('header.notification.title.video.READY'),
                'header.notification.title.video.REMOVED': t('header.notification.title.video.REMOVED'),
                'header.notification.title.video.GENERATING': t('header.notification.title.video.GENERATING'),
                'header.notification.content.video.INITIALIZED': t('header.notification.content.video.INITIALIZED'),
                'header.notification.content.video.DOWNLOADING': t('header.notification.content.video.DOWNLOADING'),
                'header.notification.content.video.AWAIT_STACKING': t('header.notification.content.video.AWAIT_STACKING'),
                'header.notification.content.video.STACKING': t('header.notification.content.video.STACKING'),
                'header.notification.content.video.ERROR': t('header.notification.content.video.ERROR'),
                'header.notification.content.video.READY': t('header.notification.content.video.READY'),
                'header.notification.content.video.REMOVED': t('header.notification.content.video.REMOVED'),
                'header.notification.content.video.GENERATING': t('header.notification.content.video.GENERATING'),
            },
            helpDeskUsers: [],
            filteredHelpdeskUsers: [],
            afterHelpDeskUserLogin: false,
        };
        this.handleChangeCbk = this.handleChangeCbk.bind(this);
        this.blockUi = this.blockUi.bind(this);
        this.unblockUi = this.unblockUi.bind(this);
        this.handleShowTooltip = this.handleShowTooltip.bind(this);
        this.handleHideTooltip = this.handleHideTooltip.bind(this);
    }
    getHelpDeskUsers() {
        this.accountService
            .getHelpDeskUsers()
            .then((helpDeskUsers) =>
                this.setState({ helpDeskUsers, filteredHelpdeskUsers: helpDeskUsers })
            )
            .catch(() => {
            });
    }

    componentDidMount() {
        const {t} = this.props;
        if(this.state.helpDeskUsers.length === 0 && (this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
        this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
        this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
        this.authService.getProfile().helpdeskUserRole === 'HOTLINE')
){
            this.getHelpDeskUsers();

        }

        if (!sessionStorage.getItem('i18nextLng')) {
            this.authService.refresh().then((res) => {
                sessionStorage.setItem('i18nextLng', res.language);
                i18n.changeLanguage(res.language);
            });
        }
        this.timer = setInterval(() => {
            this.setState({
                timer: this.authService.expirationTimer(),
            });
            if (!this.authService.loggedIn()) {
                if (this.props.logout) {
                    this.props.logout();
                } else {
                    this.authService.logout();
                }
            }
        }, 1000);
        let translations = {
            'header.notification.clear': t('header.notification.clear'),
            'header.notification.title.video.INITIALIZED': t('header.notification.title.video.INITIALIZED'),
            'header.notification.title.video.DOWNLOADING': t('header.notification.title.video.DOWNLOADING'),
            'header.notification.title.video.AWAIT_STACKING': t('header.notification.title.video.AWAIT_STACKING'),
            'header.notification.title.video.STACKING': t('header.notification.title.video.STACKING'),
            'header.notification.title.video.ERROR': t('header.notification.title.video.ERROR'),
            'header.notification.title.video.READY': t('header.notification.title.video.READY'),
            'header.notification.title.video.REMOVED': t('header.notification.title.video.REMOVED'),
            'header.notification.title.video.GENERATING': t('header.notification.title.video.GENERATING'),
            'header.notification.content.video.INITIALIZED': t('header.notification.content.video.INITIALIZED'),
            'header.notification.content.video.DOWNLOADING': t('header.notification.content.video.DOWNLOADING'),
            'header.notification.content.video.AWAIT_STACKING': t('header.notification.content.video.AWAIT_STACKING'),
            'header.notification.content.video.STACKING': t('header.notification.content.video.STACKING'),
            'header.notification.content.video.ERROR': t('header.notification.content.video.ERROR'),
            'header.notification.content.video.READY': t('header.notification.content.video.READY'),
            'header.notification.content.video.REMOVED': t('header.notification.content.video.REMOVED'),
            'header.notification.content.video.GENERATING': t('header.notification.content.video.GENERATING'),
        };
        this.setState({
            loggedIn: this.authService.loggedIn(),
            timer: this.authService.expirationTimer(),
            translations: translations,
        });
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
        i18n.changeLanguage();
        //this._isMounted = false;
    }

    changeRoleType(sapRoleId) {
        this.userService.changeRoleType(sapRoleId).then((res) => {
            this.authService.setToken(res.token);
            window.location.href = '/#/start';
            window.location.reload();
        });
    }

    changeLanguage(language) {
        this.userService.changeLanguage(language).then(() => {
            sessionStorage.setItem('i18nextLng', language);
            i18n.changeLanguage(language);
        });
    }
    itemTemplate(item) {
        return (
            <div className='hd-cbk-select'>
                <span>{item.caption}</span>
            </div>
        );
    }
    blockUi(callBack, waitPanelLabel) {
        if (this.props.blockUi !== undefined && this.props.blockUi instanceof Function) {
            this.props.blockUi(undefined, waitPanelLabel);
        }
        if (waitPanelLabel !== undefined) {
            this.setState({blocking: true, waitPanelLabel}, () =>
                callBack !== undefined && callBack instanceof Function ? callBack() : null
            );
        } else {
            this.setState({blocking: true}, () => (callBack !== undefined && callBack instanceof Function ? callBack() : null));
        }
    }

    unblockUi(callBack) {
        if (this.props.unblockUi !== undefined && this.props.unblockUi instanceof Function) {
            this.props.unblockUi();
        }
        this.setState({blocking: false}, () => (callBack !== undefined && callBack instanceof Function ? callBack() : null));
    }

    blockHeaderLoadingCbk(){
        this.setState({loadingCbk: true});
    }

    unblockHeaderLoadingCbk(){
        this.setState({loadingCbk: false});
    }

    handleShowTooltip() {
        this.setState({nameTooltipVisible: true});
    }

    handleHideTooltip() {
        this.setState({nameTooltipVisible: false});
    }
    handleChangeCbk(e) {
        if (e !== undefined) {
            e.preventDefault();
        }
        
         this.blockHeaderLoadingCbk();
           this.authService.switchCbk( this.state.helpdeskUser?.cbkId)
                .then((res) => {
                    if(res !== undefined){
                        const user = this.authService.getProfile();
                        if (user && !!user.helpDeskUser && !this.state.helpdeskUser) {

                        } else  {
                            window.location.reload();
                        }  
                    } else {
                        if(window.location.hash === '#/start'){
                            window.location.reload(); 
                        } else {
                            window.location.href = '/#/start';
                        }      
                           
                    }
                   
                    
                }, () =>  this.unblockHeaderLoadingCbk());
     
    }

    renderAfterLogin() {
        if (this.authService.loggedIn() && (!this.authService.getProfile().helpDeskUser || !!this.state.afterHelpDeskUserLogin)) {
            this.getHelpDeskUsers();
            return this.renderAfterAuth();
        } else {
            return this.renderBeforeAuth();
        }
    }

    renderAfterAuth() {
        const {redirectToReferrer} = this.state;
        const bankWorker = (this.authService.getProfile().helpdeskUserRole === 'BANK_SGB' || this.authService.getProfile().helpdeskUserRole === 'BANK_BPS');
        if (redirectToReferrer === true && bankWorker === false) {
            return <Redirect to={this.targetLocation ? this.targetLocation : '/start'} />;
        }
        return <Redirect to={'/start'} />;
    }
    loader() {
        let label = 'Operacja w toku, proszę czekać.';
        return (
            <div id='cover-spin-container'>
                <div id='cover-spin' />
                <div id='cover-spin-text'>
                    <p>{label}</p>
                </div>
            </div>
        );
    }
    render() {
        const {t} = this.props;
        const supportedLanguages = I18nUtils.getSupportedLanguages(2);
        const languages = [];
        supportedLanguages.forEach((l) => {
            languages.push({value: l, label: t(`header.${l}`)});
        });
        return (
            <React.Fragment>
                   {this.authService.loggedIn() ? (
                    <header className='container-fluid'>
                        <div className='session-div'>
                            <span className='session-label'>
                                {t('header.sessionTimer')}: <span className='session-time'>{this.state.timer}</span>
                            </span>


                        </div>
                        <BlockUi
                          tag='div'
                          blocking={this.state.loadingCbk}
                          loader={this.loader.bind(this)}
                          loaderType='small-loader mobile-user-loader'
                          horizontal
                                            >
                        <div className='header-content'>
                            {this.props.label ? (
                                this.props.backUrl ? (
                                    <ActionLink
                                        label={t(this.props.label)}
                                        className='back-blue-link header-welcome-link'
                                        href={this.props.backUrl}
                                        variant='blue'
                                        iconName='mdi-arrow-left left-arrow-style'
                                        iconSide='left'
                                        iconSize='xs'
                                        iconColor='blue'
                                    />
                                ) : (
                                    <span className='header-welcome header-welcome-label'>{t(this.props.label)}</span>
                                )
                            ) : this.props.hideBankWelcome ? null :(
                                 !(this.authService.getProfile().helpdeskUserRole === 'BANK_SGB' || this.authService.getProfile().helpdeskUserRole === 'BANK_BPS') ?
                                <span id='contractor-name-id' className='header-welcome' eventListeners={[
                                    {
                                        eventName: 'mouseenter',
                                        fnc: this.handleShowTooltip,
                                        eventElementId: 'contractor-name-id',
                                    },
                                ]}>
                                 
                                    {t('header.welcome')},
                                    <b>
                                         {`${
                                            this.authService.getProfile().fullName &&
                                            this.authService.getProfile().fullName.trim().length > 0
                                                ? this.authService.getProfile().fullName + ', '
                                                : ''
                                        } ${this.authService.getProfile().companyName}`} 
                                       
                                    </b> 
                                </span>: <span id='bank-contractor-name-id' className='header-welcome'> {t('header.welcome')}, Pracowniku Banku {this.authService.getProfile().helpdeskUserRole === 'BANK_SGB' ? "SGB" : "BPS"}</span>
                                        
                            )}
                            <div className='tooltip-label header' >
                                                    <TooltipComponent
                                                            id='mpk-tooltip-name'
                                                            key='mpk-tooltip-name'
                                                            visible={this.state.nameTooltipVisible}
                                                            content={this.authService.getProfile().companyName}
                                                            eventListeners={[
                                                                {
                                                                    eventName: 'mouseleave',
                                                                    fnc: this.handleHideTooltip,
                                                                    eventElementId: 'contractor-name-id',
                                                                },
                                                                {
                                                                    eventName: 'mouseenter',
                                                                    fnc: this.handleShowTooltip,
                                                                    eventElementId: 'contractor-name-id',
                                                                },
                                                            ]}
                                                        />
                                                        </div>
                            {this.authService.getProfile().helpDeskUser &&
                            (this.authService.getProfile().helpdeskUserRole === 'HELPDESK'  ||
                               this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' || 
                               this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' || 
                               this.authService.getProfile().helpdeskUserRole === 'HOTLINE'
                            ) ? 
                            <div className='col-xl-3 col-lg-3 col-md-2 col-sm-2 header-contractor'>
                                <InputAutocompleteComponent
                                id='helpdeskUser'
                                name='helpdeskUser'
                                label={t('login.helpdeskDialog.helpdeskUser')}
                                showLabel={false}
                                colClass='col-8 header-contractor-autocomplete'
                                panelClassName='hd-auto-complete-panel'
                                value={this.state.helpdeskUser}
                                viewMode='EDIT'
                                validator={this.validator}
                                validators='required'
                                stateField=''
                                onChange={(a,b,c,d,e) => {
                                if (c.value !== undefined && c.value !== null) {
                                    this.setState({helpdeskUser: c.value});
                                }
                            }}
                                rendered={true}
                                filterList={(query) => {
                                    let filteredHelpdeskUsers = [];
                                    if (query && query !== '' && this.state.helpDeskUsers && this.state.helpDeskUsers.length > 0) {
                                        this.state.helpDeskUsers.forEach((el) => {
                                            if (el.caption.toLowerCase().includes(query.toLowerCase())) {
                                                filteredHelpdeskUsers.push(el);
                                            }
                                        });
                                    } 
                                    this.setState({filteredHelpdeskUsers});
                                }}
                                filteredList={this.state.filteredHelpdeskUsers}
                                dropdown
                                field='caption'
                                forceSelection
                                minLengthQuery={3}
                                minLength={3}
                                placeholder={"Kontrahent"}
                                itemTemplate={this.itemTemplate}
                            />
                            <ActionButton
                                    label={'Zmień'}
                                    className='col-3'
                                    // handleClick={(e) => { 
                                    //     if (e.value !== this.state.sapRoleId) {
                                    //     this.setState(
                                    //         {
                                    //             helpdeskUser: e.value,
                                    //         },
                                    //         () => this.handleChangeCbk()
                                    //     );
                                    // }}}
                                    handleClick={()=>{
                                        this.handleChangeCbk();
                                    }}
                                    disabled={this.state.captchaPreventAction || !this.state.helpdeskUser}
                                />
                            </div>
                            : null
                            }
                            
                              {!(this.authService.getProfile().helpdeskUserRole === 'BANK_SGB' || this.authService.getProfile().helpdeskUserRole === 'BANK_BPS') ?
                              
                              <NotificationComponentProp
                              token={this.authService.getToken()}
                              cbkId={this.authService.getCbkId()}
                              translations={this.state.translations}
                              websocket={this.props.websocket}
                          /> : null
                            
                            }
                          
                            <div className='header-links'>
                           
                                {this.authService.getProfile().sapRoleIdsList?.length > 1 && this.authService.getProfile().userType !== 'STANDARD' && !(this.authService.getProfile().helpdeskUserRole === 'BANK_SGB' || this.authService.getProfile().helpdeskUserRole === 'BANK_BPS')? (
                                    <div className='header-link dropdown'>
                                        <span className='dropdown-label'>{`${t('header.agreement')}: `}</span>
                                        <Dropdown
                                            emptyMessage={!!t && t instanceof Function ? t('list.emptyDropdown') : 'Brak dostępnych opcji'}
                                            options={this.authService.getProfile().sapRoleIdsList.map((el) => {
                                                return {value: el, label: t(`header.${el}`)};
                                            })}
                                            optionLabel='label'
                                            optionValue='value'
                                            value={this.state.sapRoleId}
                                            onChange={(e) => {
                                                if (e.value !== this.state.sapRoleId) {
                                                    this.setState(
                                                        {
                                                            sapRoleId: e.value,
                                                        },
                                                        () => this.changeRoleType(this.state.sapRoleId)
                                                    );
                                                }
                                            }}
                                        />
                                    </div>
                                ) : null}
                                {languages.length > 1  &&  !(this.authService.getProfile().helpdeskUserRole === 'BANK_SGB' || this.authService.getProfile().helpdeskUserRole === 'BANK_BPS') ? (
                                    <div className='header-link dropdown'>
                                        <span className='dropdown-label'>{`${t('header.language')}: `}</span>
                                        <Dropdown
                                            emptyMessage={!!t && t instanceof Function ? t('list.emptyDropdown') : 'Brak dostępnych opcji'}
                                            options={languages}
                                            optionLabel='label'
                                            optionValue='value'
                                            value={i18n.language.split('-')[0]}
                                            onChange={(e) => {
                                                if (e.value !== sessionStorage.getItem('i18nextLng')) {
                                                    this.changeLanguage(e.value);
                                                }
                                            }}
                                        />
                                    </div>
                                ) : null}
                                 {!(this.authService.getProfile().helpdeskUserRole === 'BANK_SGB' || this.authService.getProfile().helpdeskUserRole === 'BANK_BPS') ?
                                <ActionLink
                                    label={t('header.contact')}
                                    href={'/#/contact'}
                                    variant='blue'
                                    className='p-link header-link'
                                    key={'contact-button'}
                                /> : null}
                                {/* <ActionLink
                                    label={t('header.faq')}
                                    href={'/#/faq'}
                                    variant='blue'
                                    className='p-link header-link'
                                    key={'faq-button'}
                                /> */}
                                {!!this.props.hideLogout ? null: 
                                <div onClick={this.props.logout} className='header-link' rel='noopener noreferrer'>
                                    <span className='nowrap-span'>{t('header.logout')}</span>
                                </div>}
                            </div>
                        </div>
                        </BlockUi>
                    </header>

                ) : null}
            </React.Fragment>
        );
    }
}

export default withTranslation()(HeaderComponent);
